<template>
  <div class="bonusPolicy h100">
    <!-- <h1>This is an bonusPolicy page</h1> -->
    <el-card>
      <el-button class="mb20" type="primary" @click="add()" v-if="roles.indexOf('Admin')>-1 || roles.indexOf('SIP')>-1">添 加</el-button>
      <!-- 搜索 -->
      <el-form ref="searchListRef" :model="searchList" :inline="true">
        <el-form-item label="年份" prop="year">
          <el-date-picker v-model="searchList.year" type="year" value-format="yyyy" placeholder="请选择年份"></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="季度" prop="quarter">
          <el-select v-model="searchList.quarter" placeholder="请选择季度">
            <el-option label="Q1" value="Q1"></el-option>
            <el-option label="Q2" value="Q2"></el-option>
            <el-option label="Q3" value="Q3"></el-option>
            <el-option label="Q4" value="Q4"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="渠道">
          <el-select v-model="searchList.channel" placeholder="请选择渠道">
            <el-option v-for="(items, index) in channelData" :key="index" :label="items.name" :value="items.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search()">搜 索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetSearch()" plain>清 空</el-button>
        </el-form-item>
      </el-form>
      <!-- 奖金政策列表 -->
      <el-table ref="tableData" :data="policyList" border :span-method="objectSpanMethod" header-cell-class-name="headerStyle" cell-class-name="cellStyle">
        <el-table-column prop="year" label="年份"></el-table-column>
        <el-table-column prop="channel" label="渠道"></el-table-column>
        <el-table-column prop="quarter" label="季度"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
        <el-table-column prop="createUser" label="创建人"></el-table-column>
        <el-table-column prop="policyUploadTime" label="政策上传状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.file!==null?'success':'danger'" disable-transitions>{{scope.row.file!==null?'已上传':'未上传'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="file.createTime" label="政策上传时间" width="180"></el-table-column>
        <el-table-column prop="file.createUser" label="政策上传人"></el-table-column>
        <el-table-column prop="file.fileName" label="政策文件"></el-table-column>
        <el-table-column prop="" label="政策上传" width="100" v-if="roles.indexOf('Admin')>-1 || roles.indexOf('SIP')>-1">
          <template slot-scope="scope">
            <el-upload ref="uploadRef" :multiple='false' action :http-request="upload" :data={id:scope.row.id} :show-file-list='false' :before-upload="beforeUpload">
              <i class="el-icon-upload2 downloadIcon"></i>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column prop="updateUser" label="政策下载" width="100">
          <template slot-scope="scope">
            <i class="el-icon-download downloadIcon" @click="download(scope.row)"></i>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" v-if="roles.indexOf('Admin')>-1 || roles.indexOf('SIP')>-1">
          <template slot-scope="scope">
            <span class="operation" @click="deleting(scope.row)">删除</span>
            <!-- <el-button type="primary" @click="deleting(scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 添加奖金政策弹框 -->
    <el-dialog :title="title" width="30%" :visible.sync="dialog" @close="cancel()">
      <el-form ref="editDataRef" :rules="editDataRules" :model="editData" label-width="60px">
        <el-form-item prop="year" label="年份">
          <el-date-picker v-model="editData.year" type="year" value-format="yyyy" placeholder="请选择年份"></el-date-picker>
        </el-form-item>
        <el-form-item prop="channel" label="渠道">
          <el-select v-model="editData.channel" placeholder="请选择渠道">
            <el-option v-for="(items, index) in channelData" :key="index" :label="items.name" :value="items.name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'bonusPolicy',
  data () {
    return {
      // 用户信息
      userInfo: '',
      roles: [],
      policyList: [], // 奖金政策列表
      dialog: false,
      channelData: [],
      searchList: {
        year: null,
        quarter: null,
        channel: null
      },
      editData: {
        year: '',
        channel: ''
      },
      editDataRules: {
        year: [
          { required: true, message: '请选择年份', trigger: 'blur' }
        ],
        channel: [
          { required: true, message: '请选择渠道', trigger: 'change' }
        ]
      },
      // 合并单元格
      yearArr: [],
      yearPos: '',
      channelArr: [],
      channelPos: ''
    }
  },
  created () {},
  mounted () {
    this.getSessionRoles()
    this.getChannelList()
    this.getPolicyList()
  },
  methods: {
    // 奖金政策--列表
    getPolicyList (message) {
      this.policyList = []
      this.$http.post(this.API.policyList, this.searchList).then((res) => {
        let data = res.data
        if (data.data.length > 0) {
          this.policyList = data.data
          // 年和渠道排序
          this.policyList.sort(this.mysort)
          // 合并单元格
          this.getSpanArr(this.policyList)
          // 处理筛选项
          if (message) {
            this.$message.success('搜索成功！')
          }
        } else {
          this.$message.warning('暂无数据！')
        }
      })
    },
    // 获取渠道列表
    getChannelList () {
      this.channelData = []
      this.$http.get(this.API.channelList).then(res => {
        // console.log(res)
        let data = res.data
        this.channelData = data.data
      })
    },
    // 奖金政策--新增
    add () {
      this.dialog = true
    },
    // 搜索
    search () {
      this.getPolicyList(true)
    },
    // 清空搜索
    resetSearch () {
      this.searchList = {
        year: null,
        quarter: null,
        channel: null
      }
      this.getPolicyList()
    },
    // 取消
    cancel () {
      this.$refs.editDataRef.resetFields()
      this.dialog = false
    },
    // 确认
    confirm () {
      this.$refs.editDataRef.validate((valid) => {
        if (valid) {
          this.dialog = false
          // 更新奖金政策
          this.$http.post(this.API.policySave, this.editData).then(res => {
            this.$message.success('添加成功！')
            this.getPolicyList()
            this.$refs.editDataRef.resetFields()
          })
        }
      })
    },
    // 奖金政策--删除
    deleting (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(this.API.policyDelete, { year: row.year, channel: row.channel }).then((res) => {
          this.getPolicyList()
          this.$message.success('删除成功！')
        })
      }).catch(() => {
        this.$message.warning('已取消删除！')
      })
    },
    // 上传前校验
    beforeUpload (file) {
      // console.log(file)
      // file.name-文件名字
      // file.size-文件大小
      // file.type-文件类型
      // 上传前格式与大小校验
      const isExcel = file.type === 'application/pdf'
      // const isLt2M = file.size / 1024 / 1024 < 2
      if (!isExcel) {
        this.$message.error('上传模板只能是PDF格式!')
      }
      // if (!isLt2M) {
      //   this.$message.error('上传模板大小不能超过 2MB!')
      // }
      // return isJPG && isLt2M
      return isExcel
    },
    // 上传
    upload (row) {
      // console.log(e)
      let formData = new FormData()
      formData.append('relationId', row.data.id)
      formData.append('businessType', 'policy')
      formData.append('file', row.file)
      this.$http.post(this.API.fileUpload, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        // console.log(res)
        this.$message.success('政策上传成功！')
        this.getPolicyList()
      })
    },
    // 下载
    download (row) {
      if (row.file === null) {
        this.$message.warning('暂未上传政策！')
      } else {
        this.$http.get(this.API.fileDownload, { params: { relationId: row.id, businessType: 'policy' }, responseType: 'blob' }).then(res => {
        // console.log(res)
          let blob = new Blob([res.data], { type: res.data.type })
          let downloadElement = document.createElement('a')
          let href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.href = href
          downloadElement.download = row.file.fileName // 下载后文件名
          document.body.appendChild(downloadElement) // 添加元素
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
          this.$message.success('下载成功！')
        })
      }
    },
    // 获取session用户信息
    getSessionRoles () {
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      if (this.userInfo !== null) {
        let arr = this.userInfo.roles
        let roles = []
        if (arr != null && arr.length > 0) {
          arr.forEach(ele => {
            roles.push(ele.roleName)
          })
        }
        this.roles = roles
      }
    },
    // 排序-季度和渠道
    mysort (a, b) {
      if (a.year !== b.year) {
        return a.year < b.year ? -1 : 1
      } else if (a.channel !== b.channel) {
        return a.channel < b.channel ? -1 : 1
      } else if (a.quarter !== b.quarter) {
        return a.quarter < b.quarter ? -1 : 1
      }
    },
    getSpanArr (data) {
      this.yearArr = []
      this.yearPos = 0
      this.channelArr = []
      this.channelPos = 0
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this.yearArr.push(1)
          this.yearPos = 0 // pos是spanArr的索引
          this.channelArr.push(1)
          this.channelPos = 0
        } else {
          // 第一行
          // 判断当前元素与上一个元素是否相同
          if (data[i].year === data[i - 1].year) {
            // 相同的话 就加一 表示合并行数加一  0表示该行不显示
            this.yearArr[this.yearPos] += 1
            this.yearArr.push(0)
          } else {
            // 不相同就添加一位1 并设置索引位置
            this.yearArr.push(1)
            this.yearPos = i
          }
          // 第二行
          if (
            data[i].year === data[i - 1].year &&
            data[i].channel === data[i - 1].channel
          ) {
            this.channelArr[this.channelPos] += 1
            this.channelArr.push(0)
          } else {
            this.channelArr.push(1)
            this.channelPos = i
          }
        }
        // console.log('spanarr', this.spanArr)
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 11) {
        const _row1 = this.channelArr[rowIndex]
        const _col1 = _row1 > 0 ? 1 : 0
        // console.log(`rowspan:${_row} colspan:${_col}`)
        // [0,0] 表示这一行不显示， [2,1]表示行的合并数
        return {
          rowspan: _row1,
          colspan: _col1
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
// 下拉选项宽度撑满
.el-select {
  width: 100% !important;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100% !important;
}
</style>
